<template>
  <div class="main-content">
    <div class="page-header">
      <h3 class="page-title">Tipo de cuenta</h3>
      <ol class="breadcrumb">
        <li class="breadcrumb-item">
          <a href="#">Home</a>
        </li>
        <li class="breadcrumb-item">
          <a href="#">Cuenta</a>
        </li>
        <li class="breadcrumb-item active">Tipo de cuenta</li>
      </ol>
    </div>
    <div class="card">
      <div class="card-header">
        <!-- <h6>Categoría</h6> -->
        <button type="button" class="btn btn-theme" @click="openModal('register', '')">Nuevo</button>
      </div>
      <div class="card-body">
        <div class="form-group row">
          <div class="col-md-6">
            <div class="input-group">
              <input v-model="search" type="text" class="form-control" placeholder="Ingrese el nombre de categoría" @keyup="fetchData(1,search)">
              <button type="submit" class="btn btn-theme" @click="fetchData(1,search)"><i class="icon-fa icon-fa-search"/> Buscar</button>
            </div>
          </div>
        </div>
        <table class="table">
          <thead>
            <tr>
              <th>Nombre</th>
              <th>Estado</th>
              <th>Fecha de registro</th>
              <th>Opciones</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="type in arrayTypes" :key="type.id">
              <td v-text="type.name"/>
              <td>
                <span v-if="type.state==1" class="btn btn-success btn-sm">Activo</span>
                <span v-else class="btn btn-danger btn-sm">Desactivado</span>
              </td>
              <td v-text="type.created_at"/>
              <td>
                <template>
                  <div class="table__actions">
                    <button :href="`#${type.name}`" class="btn btn-theme" @click="openModal('update', type)"><i class="icon-fa icon-fa-pencil"/> Editar </button>
                    <a href=""/>
                    <!-- Preguntar si se deja editar y desactivar escrito o solo los iconos -->
                    <button v-if="type.state==1" :href="`#${type.name}`" class="btn btn-danger" @click="openModal('deactivate', type)"><i class="icon-fa icon-fa-trash"/> Desactivar </button>
                    <button v-else :href="`#${type.name}`" class="btn btn-info" @click="openModal('activate',type)"><i class="icon-fa icon-fa-trash"/> Activar </button>
                  </div>
                </template>
              </td>
            </tr>
          </tbody>
        </table>
        <!--Paginación de tabla-->
        <div class="card">
          <div class="card-body">
            <ul class="pagination pagination-primary m-b-0">
              <li v-if="pagination.current_page > 1" class="page-item">
                <a class="page-link" href="#" @click.prevent="changePage(pagination.current_page - 1, search)"><i class="icon-fa icon-fa-angle-left"/></a>
              </li>
              <li v-for="page in pagesNumber" :class="[page == isActived ? 'active' : '']" :key="page" class="page-item">
                <a class="page-link" href="#" @click.prevent="changePage(page, search)" v-text="page"/>
              </li>
              <li v-if="pagination.current_page < pagination.last_page" class="page-item">
                <a class="page-link" href="#" @click.prevent="changePage(pagination.current_page + 1, search)"><i class="icon-fa icon-fa-angle-right"/></a>
              </li>
            </ul>
          </div>
        </div>
        <!-- Tabla maquetada por Arturo y Pedro-->
      </div>

      <!-- MODALES -->
      <sweet-modal ref="categoria_modal" :title="titleModal" hide-close-button blocking>
        <!-- START FORM -->
        <div class="card-body">
          <div class="form-group">
            <label>Nombre</label>
            <input
              :class="{ 'is-invalid': $v.name.$error }"
              v-model.trim="name"
              class="form-control"
              @input="$v.name.$touch()"
            >
            <div v-if="$v.name.$error">
              <span
                v-if="!$v.name.required"
                class="help-block help-block-error"
              >El campo es requerido</span>
              <span
                v-if="!$v.name.minLength"
                class="help-block help-block-error"
              >El minimo del caracteres es de {{ $v.name.$params.minLength.min }} letras.</span>
            </div>
          </div>
        </div>
        <!-- END FORM -->
        <button slot="button" type="button" class="btn btn-danger" @click="closeModal()">Cancelar</button>
        <button
          v-if="typeAction == 1"
          slot="button"
          type="button"
          class="btn btn-primary ladda-button"
          data-style="expand-right"
          @click="saveType()"
        >Guardar</button>
        <button
          v-if="typeAction == 2"
          slot="button"
          type="button"
          class="btn btn-primary ladda-button"
          data-style="expand-right"
          @click="updateType()"
        >Actualizar</button>
      </sweet-modal>
      <sweet-modal
        ref="activar_modal"
        icon="info"
      >
        {{ tituloModalActivar }}
        <button
          slot="button"
          type="button"
          class="btn btn-info"
          @click="$refs.activar_modal.close()"
        >
          Cancelar
        </button>
        <button
          v-if="typeAction == 3"
          slot="button"
          type="button"
          class="btn btn-danger"
          @click="deactivateType()"
        >
          Continuar
        </button>
        <button
          v-if="typeAction == 4"
          slot="button"
          type="button"
          class="btn btn-success"
          @click="activateType()"
        >
          Continuar
        </button>
      </sweet-modal>
    </div>
  </div>
</template>

<script>
import { SweetModal, SweetModalTab } from 'sweet-modal-vue'
import { required, minLength } from 'vuelidate/lib/validators'
import ladda from 'ladda'

export default {
  components: {
    SweetModal,
    SweetModalTab
  },
  data () {
    return {
      titleModal: '',
      name: '',
      id: 0,
      typeAction: 1,
      tituloModalActivar: '',
      arrayTypes: [],
      pagination: {
        'total': 0,
        'current_page': 0,
        'per_page': 0,
        'last_page': 0,
        'from': 0,
        'to': 0
      },
      offset: 3,
      search: ''
    }
  },
  install (Vue, options) {
    Vue.component('SweetModal', SweetModal)
    Vue.component('SweetModalTab', SweetModalTab)
  },
  validations: {
    name: {
      required,
      minLength: minLength(4)
    }
  },
  computed: {
    isActived: function () {
      return this.pagination.current_page
    },
    pagesNumber: function () {
      if (!this.pagination.to) {
        return []
      }
      var from = this.pagination.current_page - this.offset
      if (from < 1) {
        from = 1
      }
      var to = from + (this.offset * 2)
      if (to >= this.pagination.last_page) {
        to = this.pagination.last_page
      }
      var pagesArray = []
      while (from <= to) {
        pagesArray.push(from)
        from++
      }
      return pagesArray
    }
  },
  mounted () {
    this.fetchData(1, this.search)
  },
  methods: {
    changePage (page, search) {
      let me = this
      // Actualiza la página actual
      me.pagination.current_page = page
      // Envia la petición para visualizar la data de esa página
      me.fetchData(page, search)
    },
    async fetchData (page, search) {
      let me = this
      const response = await axios.get(
        `/api/admin/typeaccount/get?page=${page}&search=${search}`)
        .then(function (response) {
          me.arrayTypes = response.data.types.data
          me.pagination = response.data.pagination
        })
        .catch(function (error) {
          console.log(error)
        })
    },
    saveType () {
      var l = ladda.create(document.querySelector('.ladda-button'))
      this.$v.$touch()
      let me = this
      if (this.$v.$invalid) {
        toastr.error('Revise los campos', 'Error')
      } else {
        l.start()
        axios.post('/api/admin/typeaccount/', {
          name: this.name
        })
          .then(function (response) {
            toastr.success(response.data.message, 'Listo')
            l.stop()
            me.closeModal()
          })
          .catch(function (error) {
            l.stop()
            toastr.error(error.response.data.message, 'Error')
          })
      }
    },
    updateType () {
      var l = ladda.create(document.querySelector('.ladda-button'))
      this.$v.$touch()
      let me = this
      if (this.$v.$invalid) {
        toastr.error('Revise los campos', 'Error')
      } else {
        l.start()
        axios.put('/api/admin/typeaccount/update', {
          name: this.name,
          id: this.id
        })
          .then(function (response) {
            toastr.success(response.data.message, 'Listo')
            l.stop()
            me.closeModal()
          })
          .catch(function (error) {
            l.stop()
            toastr.error(error.response.data.message, 'Error')
          })
      }
    },
    activateType () {
      let me = this
      axios.put('/api/admin/typeaccount/activate', {
        id: this.id
      })
        .then(function (response) {
          toastr.success(response.data.message, 'Listo')
          me.closeModal()
        })
        .catch(function (error) {
          toastr.error(error.response.data.message, 'Error')
        })
    },
    deactivateType () {
      let me = this
      axios.put('/api/admin/typeaccount/deactivate', {
        id: this.id
      })
        .then(function (response) {
          toastr.success(response.data.message, 'Listo')
          me.closeModal()
        })
        .catch(function (error) {
          toastr.error(error.response.data.message, 'Error')
        })
    },
    openModal (accion, data = []) {
      let me = this
      switch (accion) {
        case 'register': {
          me.$refs.categoria_modal.open()
          this.titleModal = 'Nuevo tipo de cuenta'
          this.name = ''
          this.typeAction = 1
          break
        }
        case 'update': {
          me.$refs.categoria_modal.open()
          this.titleModal = 'Actualizar tipo de cuenta'
          this.name = data['name']
          this.id = data['id']
          this.typeAction = 2
          break
        }
        case 'deactivate':
        {
          me.$refs.activar_modal.open()
          this.tituloModalActivar = '¿Desea desactivar el tipo de cuenta?'
          this.id = data['id']
          this.typeAction = 3
          break
        }
        case 'activate':
        {
          me.$refs.activar_modal.open()
          this.tituloModalActivar = '¿Desea activar el tipo de cuenta?'
          this.id = data['id']
          this.typeAction = 4
          break
        }
      }
    },
    closeModal () {
      this.$refs.categoria_modal.close()
      this.name = ''
      this.titleModal = ''
      this.tituloModalActivar = ''
      this.$refs.activar_modal.close()
      this.fetchData(this.pagination.current_page, this.search)
    }
  }
}
</script>



// WEBPACK FOOTER //
// resources/js/views/admin/account/TypeAccount.vue